import { useClientStore } from '@/stores/client'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

/**
 * Guard for the error route that redirects to home on fresh page load.
 * This prevents users from getting stuck on the error page after a browser reload.
 */
export const errorGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> => {
  const clientStore = useClientStore()

  // If clientFullPath exists in store, we navigated here normally (after an error)
  // Let the error page show
  if (clientStore.clientFullPath) {
    next()
    return
  }

  // Fresh page load - redirect to home
  next({ name: 'home' })
}
